"use client";

import { c as _c } from "react/compiler-runtime";
import { UserCog, X } from "lucide-react";
import { useAuth } from "@/lib/auth";

/**
 * Banner displayed when an admin is impersonating another user.
 * Shows the impersonated user's info and provides a way to stop.
 */
export function ImpersonationBanner() {
  const $ = _c(14);
  const {
    isImpersonating,
    impersonatedUser,
    stopImpersonation
  } = useAuth();
  if (!isImpersonating || !impersonatedUser) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <UserCog className="w-4 h-4 flex-shrink-0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== impersonatedUser.adminEmail) {
    t1 = <span className="font-medium">{impersonatedUser.adminEmail}</span>;
    $[1] = impersonatedUser.adminEmail;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = impersonatedUser.targetUserName || impersonatedUser.targetUserEmail;
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="font-semibold">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="flex items-center gap-3">{t0}<span>{t1} angemeldet als{" "}{t3}</span></div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <X className="w-4 h-4" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== stopImpersonation) {
    t6 = <button onClick={stopImpersonation} className="flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-md font-medium transition-colors">{t5}Beenden</button>;
    $[9] = stopImpersonation;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="bg-amber-500 text-white px-4 py-2 text-sm"><div className="max-w-7xl mx-auto flex items-center justify-between gap-4">{t4}{t6}</div></div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}